import { render } from "./SupportBanner.vue?vue&type=template&id=405f71da&scoped=true"
import script from "./SupportBanner.vue?vue&type=script&lang=js"
export * from "./SupportBanner.vue?vue&type=script&lang=js"

import "./SupportBanner.vue?vue&type=style&index=0&id=405f71da&lang=css"
import "./SupportBanner.vue?vue&type=style&index=1&id=405f71da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405f71da"]])

export default __exports__